// utils/convertImagePath.ts
import type { StaticImageData } from 'next/image';
export type ImgSrc = string | StaticImageData;

export function toUrl(src: ImgSrc): string {
    return typeof src === 'string' ? src : src.src;
}
